import dayjs, { Dayjs } from 'dayjs';

import { SCHEDULE_OPTIONS, TIMEOUT_OPTIONS, WEEKDAYS } from '../constants/scheduleOptions';
import { Schedule, ScheduleAt } from '../types/task';

const formatTime = (dateStr: Dayjs) => dayjs(dateStr).format('HH:mm');
const formatDateTime = (dateStr: Dayjs) => dayjs(dateStr).format('MMM D, YYYY HH:mm');

function ordinal(n: number) {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
}

export const formatScheduleDisplay = (schedule: Schedule, scheduleAt?: ScheduleAt): string => {
  switch (schedule) {
    case Schedule.NOW:
    case Schedule.EVERY_MINUTE:
    case Schedule.HOURLY:
      return [...TIMEOUT_OPTIONS, ...SCHEDULE_OPTIONS].find((option) => option.value === schedule)
        .label;

    case Schedule.DAILY:
      return `Daily at ${formatTime(scheduleAt.schedule_time)}`;

    case Schedule.WEEKLY:
      return `${WEEKDAYS[scheduleAt.weekday_number].label} at ${formatTime(scheduleAt.schedule_time)}`;

    case Schedule.MONTHLY:
      return `Every month on the ${ordinal(scheduleAt.month_day)} at ${formatTime(scheduleAt.schedule_time)}`;

    case Schedule.CUSTOM_TIME:
      return formatDateTime(scheduleAt.schedule_time);

    default:
      return 'Unknown schedule';
  }
};
